import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface UpdatePhotosPayload {
  id: number;
  url: string;
}

interface ListingPhotos {
  format: string;
  order: number[];
  rotate?: number;
}

export default (makeCall: MakeCall) => (
  listingId: number,
  { order, rotate, format }: ListingPhotos,
) =>
  makeCall<UpdatePhotosPayload[]>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/photos`,
    {
      query: { format },
      data: {
        order,
        ...(rotate ? { rotate } : {}),
      },
    },
  );
